module.exports = __webpack_public_path__ + "static/media/2-4-1_Spot_UV_Glossy_02.e83a985b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-4-1_Spot_UV_Glossy_02.jpg
// module id = 1725
// module chunks = 0